import BlackoutPeriodAdd from '../components/BlackoutPeriodAdd.vue';
import BlackoutPeriodEdit from '../components/BlackoutPeriodEdit.vue';
import BlackoutPeriodList from '../components/BlackoutPeriodList.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: BlackoutPeriodList,
    meta: {
      title: 'Blackout Period List',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Blackout Periods'
        },
        {
          path: 'list',
          title: 'View Blackout Periods'
        }
      ]
    }
  },
  {
    path: 'add',
    component: BlackoutPeriodAdd,
    meta: {
      title: 'Add New Blackout Period',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Blackout Periods'
        },
        {
          path: 'add',
          title: 'Add New Blackout Period'
        }
      ]
    }
  },
  {
    path: 'edit',
    component: BlackoutPeriodEdit,
    meta: {
      title: 'Blackout Period Edit',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Blackout Periods'
        },
        {
          path: 'edit',
          title: 'Blackout Period Edit'
        }
      ]
    }
  }
];
